import getColor from "@insite/mobius/utilities/getColor";
import { secondaryNavigationStyles as styles } from "@tggstore/Overrides/Widgets/Header/SecondaryNavigation";
import { colorStrings } from "@tggstore/Utilities/variables";
import { css } from "styled-components";

export const commonStylesHeaderTypography = css`
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    text-transform: none;
`;

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        ${styles.wrapper?.css}
        ${commonStylesHeaderTypography}
    `,
};

styles.signInLink = {
    ...styles.signInLink,
    css: css`
        ${styles.signInLink?.css}
        ${commonStylesHeaderTypography}
        margin: 0;
        text-transform: none;
        color: ${getColor(colorStrings.textMain)};

        .link span {
            color: ${getColor(colorStrings.textMain)};
        }
    `,
};

styles.warehousePickupLink = {
    ...styles.warehousePickupLink,
    css: css`
        ${styles.warehousePickupLink?.css}
        ${commonStylesHeaderTypography}
        margin: 0;
        text-transform: none;
    `,
};

styles.warehouseSelectMenuWrapper = {
    ...styles.warehouseSelectMenuWrapper,
    css: css`
        ${styles.warehouseSelectMenuWrapper?.css}
        ${commonStylesHeaderTypography}
        margin-inline-end: auto;
        display: flex;
        align-items: center;
        gap: 0;
        position: relative;

        & > div {
            display: flex;
        }
    `,
};
